export const formatTimeInput = (value) => {
    let hours = value.slice(0, 2);
    let minutes = value.slice(2, 4); // might be empty
  
    // Cap hours and minutes to valid ranges
    if (parseInt(hours) > 23) hours = '23';
    if (minutes && parseInt(minutes) > 59) minutes = '59';
  
    if (value.length <= 2) {
      // only hours typed, return partial
      return hours;
    }
  
    // full or partial minute entered
    return `${hours.padStart(2, '0')}:${minutes}`;
  };
  
  
  export const convertAMPM = (time, newOption) => {
    if (!time.includes(':')) return time;
    let [hours, minutes] = time.split(':').map(Number);
    if (newOption === 'ب.ظ' && hours < 12) {
      hours += 12;
    } else if (newOption === 'ق.ظ' && hours >= 12) {
      hours -= 12;
    }
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  };  